// src/routes/AppRoutes.jsx
// Routing principal: /login publica + reset de contrasena (S48.4) +
// resto protegido por ProtectedRoute. Sprint 44 Fase 3 Vista 1: shell XL
// global con sidebar/topbar/dark mode. S48.4 agrega rutas publicas
// /forgot-password y /reset-password via authRoutes (array de <Route>).
// Sprint 50 Fase 1: monta /dashboard/* (Dashboard Premium) en inner Routes.

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import { AuthProvider } from '../auth/AuthContext';
import { TenantProvider } from '../tenant/TenantContext';
import LoginPage from '../auth/LoginPage';
import ProtectedRoute from '../auth/ProtectedRoute';
import authRoutes from './authRoutes';
import DashboardRoutes from './dashboardRoutes';

import ShellXL from '../layout/xl/ShellXL';
import { findNavItemByPath } from '../layout/xl/navModel';

import DashboardXL from '../modules/dashboard_xl/DashboardXL';
import ImportacionesRoutes from '../modules/importaciones_xl/routes';
import CouriersRoutes from '../modules/couriers_xl/routes';
import ProductosRoutes from '../modules/productos_xl/routes';
import EtiquetasRoutes from '../modules/etiquetas_xl/routes';
import PORoutes from '../modules/po_xl/routes';
import GRNRoutes from '../modules/grn_xl/routes';
import InventarioRoutes from '../modules/inventario_xl/routes';
import ClientesRoutes from '../modules/clientes_xl/routes';
import CotizacionesRoutes from '../modules/cotizaciones_xl/routes';
import VentasRoutes from '../modules/ventas_xl/routes';
import VentasListXL from '../modules/ventas_xl/VentasListXL';
import ContabilidadRoutes from '../modules/contabilidad_xl/routes';
import PickingRoutes from '../modules/picking_xl/routes';
import PackingRoutes from '../modules/packing_xl/routes';

function titleForPath(pathname) {
  const match = findNavItemByPath(pathname);
  if (match) return match.item.label;
  const segs = (pathname || '/').split('/').filter(Boolean);
  if (segs.length > 0) {
    const fakePath = '/' + segs[0];
    const pref = findNavItemByPath(fakePath);
    if (pref) return pref.item.label;
  }
  return 'StockPilot ERP';
}

function ShellRoutes() {
  const loc = useLocation();
  const title = titleForPath(loc.pathname);
  return (
    <ShellXL title={title}>
      <Routes>
        <Route path="/" element={<DashboardXL />} />
        <Route path="/dashboard/*" element={<DashboardRoutes />} />
        <Route path="/importaciones/*" element={<ImportacionesRoutes />} />
        <Route path="/couriers/*" element={<CouriersRoutes />} />
        <Route path="/productos/*" element={<ProductosRoutes />} />
        <Route path="/etiquetas/*" element={<EtiquetasRoutes />} />
        <Route path="/po/*" element={<PORoutes />} />
        <Route path="/grn/*" element={<GRNRoutes />} />
        <Route path="/inventario/*" element={<InventarioRoutes />} />
        <Route path="/clientes/*" element={<ClientesRoutes />} />
        <Route path="/cotizaciones/*" element={<CotizacionesRoutes />} />
        <Route path="/ventas/*" element={<VentasRoutes />} />
        <Route path="/ventas-xl" element={<VentasListXL />} />
        <Route path="/contabilidad/*" element={<ContabilidadRoutes />} />
        <Route path="/picking/*" element={<PickingRoutes />} />
        <Route path="/packing/*" element={<PackingRoutes />} />
        <Route path="/proveedores" element={<h1 className="p-6 text-2xl">Proveedores</h1>} />
        <Route path="/configuracion" element={<h1 className="p-6 text-2xl">Configuracion</h1>} />
      </Routes>
    </ShellXL>
  );
}

function PrivateShell() {
  return (
    <TenantProvider>
      <ShellRoutes />
    </TenantProvider>
  );
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {authRoutes}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <PrivateShell />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
